// extracted by mini-css-extract-plugin
module.exports = {"col":"TeamsFilter_col_3JUZa"};